/*===============================================================================
📁 Fichier : devis-instantane-2025-05-22.js (VERSION NETTOYÉE - SANS JAUGE LIVRAISON)
📄 Description : Script principal pour la page Shopify "Devis instantané"
===============================================================================*/

// ⬇️ Initialisation de la scène Three.js et variables globales
let scene, camera, renderer, loader, modelGroup, controls;
let selectedOrientation = "Z_NEG";
let lastEstimatePrice = 0;
let quoteItems = []; // 🟢 Variable globale synchronisée avec le serveur

const USE_TRANSPARENT_BG = false;
const AQ_I18N = window.autoQuoteI18n || {};
const t = (key, fallback) => AQ_I18N[key] || fallback;

window.dataLayer = window.dataLayer || [];

document.addEventListener("DOMContentLoaded", function () {
  initViewer();
  animate();
  initDevisEventListeners();
  chargerPanierExistant(); // 🟢 Chargement du panier au démarrage
});

// ==============================================================================
// 1. INITIALISATION & THREE.JS (CODE VISUEL)
// ==============================================================================

async function initDevisEventListeners() {
  const fileBtn = document.getElementById("customFileBtn");
  const fileInput = document.getElementById("fileInput");
  const fileNameDisplay = document.getElementById("fileNameDisplay");

  if (fileBtn && fileInput) {
    fileBtn.addEventListener("click", () => fileInput.click());
    fileInput.addEventListener("change", () => {
      const f = fileInput.files[0];
      fileNameDisplay.textContent = f ? f.name : t("noFileSelected", "Aucun fichier selectionne");
      previewSTL({ target: fileInput }); 
    });
  }

  const radios = document.querySelectorAll('input[name="technology"]');
  radios.forEach(radio => radio.addEventListener('click', updateOptions));

  const materialSelect = document.getElementById("materialSelect");
  if (materialSelect) materialSelect.addEventListener("change", updateColorOptions);

  if (document.querySelector('input[name="technology"]:checked')) updateOptions();

  const boutonDevisPopup = document.querySelector('#ouvrir-devis');
  if (boutonDevisPopup) {
    boutonDevisPopup.addEventListener('click', function (e) {
      e.preventDefault();
      const popup = document.getElementById('quoteModal');
      if (popup) popup.style.display = 'block';
    });
  }

  const closeModalButton = document.getElementById('closeModal');
  if (closeModalButton) {
    closeModalButton.addEventListener('click', () => {
      const popup = document.getElementById('quoteModal');
      if (popup) popup.style.display = 'none';
    });
  }
}

function initViewer() {
  scene = new THREE.Scene();
  scene.background = new THREE.Color(0x111111);

  const stlViewerElement = document.getElementById('stlViewer');
  if (!stlViewerElement) return;

  while (stlViewerElement.firstChild) stlViewerElement.removeChild(stlViewerElement.firstChild);

  const size = Math.min(500, stlViewerElement.clientWidth > 0 ? stlViewerElement.clientWidth : window.innerWidth * 0.9);

  camera = new THREE.PerspectiveCamera(50, 1, 0.1, 2000);
  camera.position.set(120, 90, 120);
  camera.lookAt(0, 0, 0);

  renderer = new THREE.WebGLRenderer({ antialias: true, alpha: false, preserveDrawingBuffer: true });
  renderer.setSize(size, size);
  renderer.shadowMap.enabled = true;
  renderer.shadowMap.type = THREE.PCFSoftShadowMap;
  renderer.outputEncoding = THREE.sRGBEncoding;
  renderer.toneMapping = THREE.ACESFilmicToneMapping;
  stlViewerElement.appendChild(renderer.domElement);

  controls = new THREE.OrbitControls(camera, renderer.domElement);
  controls.enableDamping = true;
  controls.target.set(0, 0, 0);

  const ambientLight = new THREE.AmbientLight(0xb0b0b0, 0.6);
  scene.add(ambientLight);
  const dirLight1 = new THREE.DirectionalLight(0xffffff, 0.8);
  dirLight1.position.set(150, 200, 100);
  dirLight1.castShadow = true;
  scene.add(dirLight1);
  const dirLight2 = new THREE.DirectionalLight(0xd0e0ff, 0.35);
  dirLight2.position.set(-120, -80, -60);
  scene.add(dirLight2);

  const grid = new THREE.GridHelper(400, 40, 0x555555, 0x222222);
  grid.position.y = 0;
  scene.add(grid);

  modelGroup = new THREE.Group();
  scene.add(modelGroup);
  loader = new THREE.STLLoader();
  createDefaultModel();

  window.addEventListener("resize", () => {
    const newWidth = stlViewerElement.clientWidth > 0 ? stlViewerElement.clientWidth : window.innerWidth * 0.9;
    const newSize = Math.min(500, newWidth);
    renderer.setSize(newSize, newSize);
    camera.aspect = 1;
    camera.updateProjectionMatrix();
  });
}

function createDefaultModel() {
  const url = "https://cdn.shopify.com/s/files/1/0565/9249/8797/files/Cute_Fox_2.stl?v=1747502080";
  loader.load(url, function (geometry) { loadSTLGeometry(geometry); }, undefined, function (error) { console.error('Erreur chargement modèle défaut:', error); });
}

function previewSTL(event) {
  const file = event.target.files[0];
  if (!file || !file.name.toLowerCase().endsWith('.stl')) { alert(t("invalidStlFile", "Veuillez selectionner un fichier STL valide.")); return; }
  const reader = new FileReader();
  reader.onload = function (e) {
    try {
      const geo = loader.parse(e.target.result);
      if (geo.getAttribute('position').count === 0) throw new Error(t("emptyGeometry", "Geometrie vide."));
      loadSTLGeometry(geo);
    } catch (error) { alert(`${t("stlFileErrorPrefix", "Erreur fichier STL")}: ${error.message}`); }
  };
  reader.readAsArrayBuffer(file);
}

function loadSTLGeometry(geometry) {
  geometry.computeVertexNormals();
  const material = new THREE.MeshPhongMaterial({ color: 0x444444, specular: 0x222222, shininess: 30, flatShading: false });
  const mesh = new THREE.Mesh(geometry, material);
  mesh.castShadow = true;
  while (modelGroup.children.length > 0) modelGroup.remove(modelGroup.children[0]);
  modelGroup.add(mesh);
  applyOrientation(selectedOrientation);
  
  const box = new THREE.Box3().setFromObject(modelGroup);
  const center = box.getCenter(new THREE.Vector3());
  const maxDim = Math.max(box.getSize(new THREE.Vector3()).x, box.getSize(new THREE.Vector3()).y, box.getSize(new THREE.Vector3()).z);
  
  camera.position.set(center.x + maxDim * 1.1, center.y + maxDim * 0.45, center.z + maxDim * 1.1);
  camera.lookAt(center);
  controls.target.copy(center);
  controls.update();
}

function applyOrientation(orientation) {
  selectedOrientation = orientation;
  if (!modelGroup.children.length) return;
  const mesh = modelGroup.children[0];
  mesh.rotation.set(0, 0, 0); mesh.position.set(0, 0, 0);
  mesh.updateMatrixWorld(true);

  const rots = { 'Z_NEG': [0,0,0], 'Z_POS': [Math.PI,0,0], 'Y_NEG': [Math.PI/2,0,0], 'Y_POS': [-Math.PI/2,0,0], 'X_NEG': [0,0,Math.PI/2], 'X_POS': [0,0,-Math.PI/2] };
  const r = rots[orientation] || [0,0,0];
  mesh.rotation.set(r[0], r[1], r[2]);
  mesh.updateMatrixWorld(true);
  
  const box = new THREE.Box3().setFromObject(mesh);
  const center = box.getCenter(new THREE.Vector3());
  mesh.position.x -= center.x; mesh.position.z -= center.z; mesh.position.y -= box.min.y;
  mesh.updateMatrixWorld(true);
}

function animate() {
  requestAnimationFrame(animate);
  if (controls) controls.update();
  if (renderer && scene && camera) renderer.render(scene, camera);
}

// ==============================================================================
// 2. GESTION DES OPTIONS & FORMULAIRE (INCHANGÉ)
// ==============================================================================

let techData = null;

async function updateOptions() {
  if (!techData && window.fetchTechnologyOptions) {
    try { techData = await window.fetchTechnologyOptions(); } catch (e) { techData = {}; }
  } else if (!techData) return;

  const technology = document.querySelector('input[name="technology"]:checked')?.value;
  const matSelect = document.getElementById('materialSelect');
  
  // Reset UI
  if (matSelect) matSelect.innerHTML = `<option value="" disabled selected>${t("chooseMaterialOption", "Choisissez un materiau")}</option>`;
  document.getElementById('materialSection').style.display = 'none';
  document.getElementById('colorSection').style.display = 'none';
  document.getElementById('fdmOptions').style.display = 'none';

  if (!technology || !techData[technology]) return;

  // Populate Materials
  document.getElementById('materialSection').style.display = 'block';
  if (matSelect && techData[technology].materials) {
    for (const mat of Object.keys(techData[technology].materials)) {
      const opt = document.createElement('option');
      opt.value = mat; opt.textContent = mat;
      matSelect.appendChild(opt);
    }
  }

  document.getElementById('colorSection').style.display = 'block';
  if (technology === "FDM") document.getElementById('fdmOptions').style.display = 'block';
  
  updateColorOptions();
}

function updateColorOptions() {
  const colorOptions = document.getElementById("colorOptions");
  if (!colorOptions) return;
  colorOptions.innerHTML = '';

  const technology = document.querySelector('input[name="technology"]:checked')?.value;
  const mat = document.getElementById("materialSelect")?.value;

  if (!technology || !mat || !techData?.[technology]?.materials?.[mat]?.colors) {
    colorOptions.innerHTML = `<p style="font-style:italic;color:#777;">${t("selectTechAndMaterial", "Selectionnez une technologie et un materiau.")}</p>`;
    return;
  }

  const colors = techData[technology].materials[mat].colors;
  if (colors.length > 0) {
    const preferredColor = new Set(["noir", "black"]);
    colorOptions.innerHTML = colors.map(c => 
      `<label><input type="radio" name="color" value="${c}" required ${preferredColor.has(c.toLowerCase()) ? 'checked' : ''}> ${capitalize(c)}</label>`
    ).join("");
    if (!document.querySelector('input[name="color"]:checked')) 
        colorOptions.querySelector('input').checked = true;
  } else {
    colorOptions.innerHTML = `<p>${t("noColorAvailable", "Aucune couleur disponible.")}</p>`;
  }
}

function capitalize(str) { return str ? str.charAt(0).toUpperCase() + str.slice(1) : ""; }

function getFormParameters(formData) {
  const technology = formData.get("technology");
  const lh = (technology === 'SLA') ? 0.05 : (parseFloat(formData.get("layerHeight")) || 0.2);
  
  return {
    technology,
    material: formData.get("material") || "PETG",
    color: formData.get("color") || "inconnu",
    layerHeight: lh,
    infillDensity: parseFloat(formData.get("infillDensity") || 25),
    wallCount: parseInt(formData.get("wallCount") || 2),
    shellLayers: parseInt(formData.get("shellLayers") || 3),
    wallThickness: 0.4
  };
}

function validateUploadForm() {
  const form = document.getElementById('uploadForm');
  if (!form || !form.checkValidity()) { alert(t("fillAllFields", "Veuillez remplir tous les champs.")); return false; }
  const file = document.getElementById("fileInput").files[0];
  if (!file) { alert(t("selectFile", "Selectionnez un fichier.")); return false; }
  if (!document.querySelector('input[name="technology"]:checked')) { alert(t("selectTechnology", "Selectionnez une technologie.")); return false; }
  return true;
}

// ==============================================================================
// 3. GESTION DES IDENTIFIANTS (Session & Panier)
// ==============================================================================

function getOrCreateRequestId() {
  let rid = sessionStorage.getItem("3dvertical_cart_id");
  if (!rid) {
    const now = new Date();
    rid = `demande_${now.toISOString().replace(/[-:.TZ]/g,"")}_${Math.floor(Math.random()*900000)}`;
    sessionStorage.setItem("3dvertical_cart_id", rid);
  }
  return rid;
}

function createPartId() {
  return "part_" + Date.now() + "_" + Math.floor(Math.random() * 10000);
}

// ==============================================================================
// 4. LOGIQUE SERVEUR (Upload & Synchro) - LE COEUR DU SYSTÈME
// ==============================================================================

async function uploadFile() {
  const loading = document.getElementById("loadingIndicator");
  const resDiv = document.getElementById("result");
  const form = document.getElementById("uploadForm");
  const file = document.getElementById("fileInput").files[0];

  if (!validateUploadForm()) return;

  const params = getFormParameters(new FormData(form));
  const requestId = getOrCreateRequestId();
  const partId = createPartId();

  try {
    if(loading) loading.style.display = "block";
    if(resDiv) resDiv.innerHTML = "";

    if (typeof window.uploadSTLToFirebase !== 'function') throw new Error(t("uploadFunctionUnavailable", "Fonction upload indisponible"));

    // 🟢 1. PRÉPARATION DE LA VUE
    setPresetView('ISO'); 
    await new Promise(r => setTimeout(r, 100)); // Pause stabilité

    console.log("🚀 Démarrage des uploads (Image + STL)...");

    // 🟢 2. LANCEMENT PARALLÈLE
    const imageUploadPromise = uploadScreenshotToFirebase(requestId, partId);
    const stlUploadPromise = window.uploadSTLToFirebase(file, requestId);

    const [previewUrl, sanitizedName] = await Promise.all([imageUploadPromise, stlUploadPromise]);

    console.log("📸 Image OK :", previewUrl);
    console.log("✅ STL OK :", sanitizedName);

    if (!sanitizedName) throw new Error("Échec de l'upload STL");

    // 3. Estimation & Ajout Serveur
    const estimationPayload = {
      ...params,
      requestId, partId,
      fileName: sanitizedName,
      quantity: 1,
      orientation: selectedOrientation,
      previewUrl: previewUrl
    };

    const res = await fetch("https://us-central1-devis-3dvertical-2025.cloudfunctions.net/estimerDevis", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(estimationPayload)
    });

    const estimation = await res.json();
    if (!res.ok || !estimation.success) throw new Error(estimation.error || t("genericServerError", "Erreur serveur."));

    console.log("✅ Estimation reçue:", estimation);

    window.dataLayer.push({
      event: 'instant_quote_estimate_success',
      quote_source: 'instant_quote',
      request_id: requestId,
      part_id: partId,
      technology: params.technology,
      file_name: sanitizedName,
      estimated_price: Number(estimation.unitPrice || 0),
      estimated_time_min: Number(estimation.estimatedTimeMin || 0)
    });

    // 4. Feedback Visuel
    displayEstimationResult({
      dimensions: estimation.dimensions, volume: estimation.volumeMM3, 
      weight: estimation.weightGrams, price: estimation.unitPrice, 
      estimatedTimeMin: estimation.estimatedTimeMin
    });

    // 5. Rechargement du panier
    await chargerPanierExistant();

  } catch (err) {
    console.error("❌ Erreur majeure:", err);
    alert(`${t("errorPrefix", "Erreur")}: ${err.message}`);
  } finally {
    if(loading) loading.style.display = "none";
  }
}

// --- RECUPÉRER PANIER ---
async function chargerPanierExistant() {
  const requestId = sessionStorage.getItem("3dvertical_cart_id");
  if (!requestId) return;

  try {
    const res = await fetch("https://us-central1-devis-3dvertical-2025.cloudfunctions.net/recupererPanier", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ requestId })
    });
    const data = await res.json();
    
    if (data.items) {
        renderFullQuoteTable(data.items);
    }

  } catch (e) { console.error("Erreur chargement panier:", e); }
}

// --- MISE À JOUR QUANTITÉ ---
async function updateQtyServer(partId, delta, currentVal) {
  const newVal = parseInt(currentVal) + delta;
  if (newVal < 1) return;

  const requestId = getOrCreateRequestId();
  document.body.style.cursor = "wait";

  try {
    const res = await fetch("https://us-central1-devis-3dvertical-2025.cloudfunctions.net/updateItemQuantity", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ requestId, partId, quantity: newVal })
    });
    const data = await res.json();
    if (data.success && data.items) renderFullQuoteTable(data.items);
  } catch (e) { console.error(e); } 
  finally { document.body.style.cursor = "default"; }
}

// --- SUPPRESSION ---
async function removeQuoteItem(partId) {
  const requestId = getOrCreateRequestId();
  document.body.style.cursor = "wait";

  try {
    const res = await fetch("https://us-central1-devis-3dvertical-2025.cloudfunctions.net/supprimerItem", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ requestId, partId })
    });
    const data = await res.json();
    
    if (data.success) {
      if (data.updatedItems) renderFullQuoteTable(data.updatedItems);
      else chargerPanierExistant();
    } else {
        alert(t("removeErrorPrefix", "Erreur suppression") + ": " + data.error);
    }
  } catch (e) { console.error(e); }
  finally { document.body.style.cursor = "default"; }
}

// ==============================================================================
// 5. RENDU DU TABLEAU (HTML) - 🟢 MISE À JOUR MAJEURE
// ==============================================================================

function renderFullQuoteTable(items) {
  const tbody = document.querySelector("#quoteTable tbody");
  if (!tbody) return;
  
  tbody.innerHTML = "";
  quoteItems = items;

  const quoteSection = document.getElementById("quoteSection");

  if (!items || items.length === 0) {
    if(quoteSection) quoteSection.style.display = "none";
    return;
  }

  items.forEach(item => {
    const p = item.parametres || {};
    const tech = (item.technologie || "").toUpperCase();

    // 1. Info Technique
    let infoLines = [
        `<b>${item.technologie}</b> - ${p.materiaux} (${p.couleur})`
    ];

    if (tech === 'SLA') {
        infoLines.push(`${t("layerHeightShort", "H. couche")}: ${p.hauteur_couche || '-'} mm`);
    } else {
        infoLines.push(`${t("layerHeightShort", "H. couche")}: ${p.hauteur_couche || '-'} mm, ${t("infillShort", "Remplissage")}: ${p.remplissage || '-'}`);
        infoLines.push(`${t("wallsShort", "Parois")}: ${p.parois || '-'}, ${t("shellsShort", "Coques")}: ${p.coques || '-'}`);
    }

    infoLines.push(`${t("volumeShort", "Volume")}: ${p.volume_mm3 || '-'} mm³, ${t("weightShort", "Poids")}: ${p.poids_g || '-'} g`);
    infoLines.push(`${t("timeShort", "Temps")}: ${p.temps_estime || '-'}`);

    const paramsHTML = infoLines.join("<br>");

    // 🟢 2. Tableau Paliers (Affichage Prix Unitaire incluant frais partagés)
    // On priorise 'priceTable' (nouvelle norme) sur 'discountTiers'
    const tableData = item.priceTable || [];
    let discountHTML = "-";

    if (Array.isArray(tableData) && tableData.length > 0) {
        const rows = tableData
            .sort((a,b) => a.qty - b.qty)
            .map(t => `<tr><td>${t.qty}</td><td>${t.price} $</td></tr>`)
            .join("");
            
        // Header explicite : "Prix Unit." pour qu'on comprenne que ce n'est pas le total
        discountHTML = `<table class="vertical-discount-table">
                          <thead><tr><th>${t("qtyHeaderShort", "Qte")}</th><th>${t("unitPriceHeaderShort", "Prix Unit.")}</th></tr></thead>
                          <tbody>${rows}</tbody>
                        </table>`;
    }

    const row = document.createElement("tr");

    const imageHTML = item.previewUrl 
      ? `<img src="${item.previewUrl}" alt="${item.nom_fichier}" style="width: 60px; height: 60px; object-fit: cover; border-radius: 5px; border: 1px solid #444; margin-bottom: 5px;">`
      : `<div style="width: 60px; height: 60px; background: #222; border-radius: 5px; display: flex; align-items: center; justify-content: center; margin-bottom: 5px; color: #555; font-size: 20px;">🧊</div>`;
    row.innerHTML = `
        <td>
            <div style="display: flex; flex-direction: column; align-items: center; text-align: center;">
                ${imageHTML}
                <span style="font-weight: 500; font-size: 0.9em;">${item.nom_fichier}</span>
            </div>
        </td>
        <td>
            <div class="qty-wrapper">
              <button type="button" class="qty-btn" onclick="updateQtyServer('${item.partId}', -1, ${item.quantite})">−</button>
              <input type="number" class="qty-input" min="1" value="${item.quantite}" onchange="updateQtyServer('${item.partId}', 0, this.value)">
              <button type="button" class="qty-btn" onclick="updateQtyServer('${item.partId}', 1, ${item.quantite})">+</button>
            </div>
        </td>
        <td style="font-size: 0.85em;">${paramsHTML}</td>
        <td>$ ${Number(item.prix_unitaire).toFixed(2)}</td>
        <td class="discount-cell">${discountHTML}</td>
        <td class="total-col" style="font-weight:bold;">$ ${Number(item.prix_total).toFixed(2)}</td>
        <td><button class="remove-item-btn" onclick="removeQuoteItem('${item.partId}')">🗑️</button></td>
    `;
    tbody.appendChild(row);
  });

  if(quoteSection) quoteSection.style.display = "block";
}

// ==============================================================================
// 6. UTILITAIRES DIVERS (PDF, Panier Shopify)
// ==============================================================================

function displayEstimationResult({ dimensions, volume, weight, price, estimatedTimeMin }) {
  const resDiv = document.getElementById("result");
  if (!resDiv) return;
  const h = Math.floor(estimatedTimeMin/60), m = estimatedTimeMin%60;
  
  resDiv.innerHTML = `
    <div>📏 ${t("dimensionsLabel", "Dimensions")} : X=${dimensions?.x} Y=${dimensions?.y} Z=${dimensions?.z} mm</div>
    <div>📦 ${t("volumeLabel", "Volume")} : ${volume} mm³ | ⚖️ ${t("weightLabel", "Poids")} : ${weight} g</div> 
    <div>⏱️ ${t("estimatedTimeLabel", "Temps estime")} : ${h}h ${m}min</div>
    <div>💰 ${t("estimatedUnitPriceLabel", "Prix unitaire estime")} : ${parseFloat(price).toFixed(2)} $ CAD</div>
  `;
}

function getQuoteSubtotal() {
  if (!quoteItems || quoteItems.length === 0) return 0;
  return quoteItems.reduce((s, i) => s + (Number(i.prix_total)||0), 0);
}

// --- PDF FORM ---
function openPdfClientForm() { 
    const el = document.getElementById("pdfClientForm");
    if(el) el.style.display = "flex"; 
}
function closePdfClientForm() { 
    const el = document.getElementById("pdfClientForm");
    if(el) el.style.display = "none"; 
}

function collectPdfClientInfo() {
  return {
    company: document.getElementById("clientCompany")?.value.trim() || "",
    name: document.getElementById("clientName")?.value.trim() || "",
    email: document.getElementById("clientEmail")?.value.trim() || "",
    phone: document.getElementById("clientPhone")?.value.trim() || "",
    street: document.getElementById("clientStreet")?.value.trim() || "",
    city: document.getElementById("clientCity")?.value.trim() || "",
    province: document.getElementById("clientProvince")?.value.trim() || "",
    postal: document.getElementById("clientPostal")?.value.trim() || ""
  };
}

function validatePdfClientForm(allowEmpty = false) {
  const requiredFieldIds = [
    "clientName",
    "clientEmail",
    "clientPhone",
    "clientStreet",
    "clientCity",
    "clientProvince",
    "clientPostal"
  ];

  for (const fieldId of requiredFieldIds) {
    const input = document.getElementById(fieldId);
    if (!input) continue;
    if (!allowEmpty && !input.reportValidity()) {
      return null;
    }
  }

  const clientInfo = collectPdfClientInfo();
  if (!allowEmpty && !clientInfo.name) {
    alert(t("fillClientInfo", "Veuillez remplir les infos client."));
    return null;
  }
  return clientInfo;
}

async function generateQuotePDFServer(allowEmpty = false, shouldDownload = true) {
  const clientInfo = validatePdfClientForm(allowEmpty);
  if (!clientInfo) return;
  
  closePdfClientForm();
  const requestId = getOrCreateRequestId();
  const shortId = requestId.includes('_') ? requestId.split('_')[1] : requestId;

  const items = quoteItems.map(i => {
      const p = i.parametres || {};
      const tech = (i.technologie || "").toUpperCase();
      
      let lines = [`${i.technologie} - ${p.materiaux} (${p.couleur})`];
      if (tech === 'SLA') {
          lines.push(`${t("layerHeightShort", "H. couche")}: ${p.hauteur_couche || '-'} mm`);
      } else {
          lines.push(`${t("layerHeightShort", "H. couche")}: ${p.hauteur_couche || '-'} mm, ${t("infillShort", "Remplissage")}: ${p.remplissage || '-'}`);
          lines.push(`${t("wallsShort", "Parois")}: ${p.parois || '-'}, ${t("shellsShort", "Coques")}: ${p.coques || '-'}`);
      }
      lines.push(`${t("volumeShort", "Vol")}: ${p.volume_mm3 || '-'} mm³, ${t("weightShort", "Poids")}: ${p.poids_g || '-'} g`);
      lines.push(`${t("timeShort", "Temps")}: ${p.temps_estime || '-'}`);

      return {
        fileName: i.nom_fichier,
        quantity: i.quantite,
        unitPrice: Number(i.prix_unitaire),
        parametersText: lines.join("\n") 
      };
  });

  if (items.length === 0 && !allowEmpty) { alert(t("emptyQuote", "Devis vide.")); return; }

  const loading = document.getElementById("loadingIndicator");
  if(loading) loading.style.display = "block";

  try {
    const res = await fetch("https://us-central1-devis-3dvertical-2025.cloudfunctions.net/generateQuotePDF", {
      method: "POST", headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        requestId, shortId, 
        clientInfo,
        items
      })
    });
    const data = await res.json();
    if (!res.ok || !data.url) throw new Error(data.error || t("pdfError", "Erreur PDF"));

    window.dataLayer.push({
      event: 'quote_pdf_generated',
      quote_source: 'instant_quote',
      request_id: requestId,
      short_id: shortId,
      item_count: items.length,
      should_download: shouldDownload
    });

    if (shouldDownload) {
      const b = await (await fetch(data.url)).blob();
      const l = document.createElement("a");
      l.href = URL.createObjectURL(b);
      l.download = `${t("pdfFilePrefix", "devis")}-${shortId}.pdf`;
      document.body.appendChild(l);
      l.click();
      document.body.removeChild(l);
    }
  } catch (e) { alert(e.message); }
  finally { if(loading) loading.style.display = "none"; }
}

// --- AJOUT AU PANIER (SHOPIFY) ---
async function addQuoteToCartBatch() {
  if (quoteItems.length === 0) return alert(t("emptyCart", "Panier vide"));
  const btn = document.querySelector('.quote-buttons .quote-button:last-child');
  const requestId = getOrCreateRequestId();

  try {
    if(btn) { btn.disabled = true; btn.textContent = t("addingToCart", "Ajout..."); }
    
    for (const item of quoteItems) {
      const p = item.parametres || {};
      
      await createTempProductAndAddToCart({
        requestId, 
        fileName: item.nom_fichier, 
        partId: item.partId,        
        tech: item.technologie, 
        material: p.materiaux, 
        color: p.couleur,
        layerHeight: parseFloat(p.hauteur_couche) || 0.2,
        infillDensity: parseFloat(p.remplissage) || 25,
        wallCount: parseInt(p.parois) || 2,
        shellLayers: parseInt(p.coques) || 3,
        printTime: p.temps_estime,
        dimensions: {x: p.x, y: p.y, z: p.z},
        weight: p.poids_g,
        price: item.prix_unitaire,
        quantity: item.quantite,
        previewImage: item.previewUrl || null
      });
    }

    console.log("✅ Produits ajoutés. Reset de la session.");

    window.dataLayer.push({
      event: 'instant_quote_add_to_cart_success',
      quote_source: 'instant_quote',
      request_id: requestId,
      item_count: quoteItems.length,
      cart_value: getQuoteSubtotal()
    });

    // on laisse GTM envoyer la balise avant de quitter la page
    setTimeout(() => {
      sessionStorage.removeItem("3dvertical_cart_id");
      quoteItems = [];
      renderFullQuoteTable([]);
      getOrCreateRequestId();
      window.location.href = t("cartUrl", "/cart");
    }, 1500);

    return;

  } catch (e) { 
      console.error(e);
      alert(t("addToCartErrorPrefix", "Erreur ajout panier") + ": " + e.message); 
  } finally { 
      if (btn) { btn.disabled = false; btn.textContent = t("addToCart", "Ajouter au panier"); }
  }
}

// --- Helpers pour Panier Shopify ---
async function createTempProductAndAddToCart(payload) {
    const CF = "https://us-central1-devis-3dvertical-2025.cloudfunctions.net/createTemporaryProduct";
    
    const serverPayload = {
        requestId: payload.requestId,
        partId: payload.partId,
        fileName: payload.fileName,
        technology: payload.tech, 
        material: payload.material,
        color: payload.color,
        layerHeight: payload.layerHeight,
        infillDensity: payload.infillDensity,
        wallCount: payload.wallCount,
        shellLayers: payload.shellLayers,
        printTime: payload.printTime,
        dimensions: payload.dimensions,
        weight: payload.weight,
        price: payload.price,
        previewImage: payload.previewImage
    };

    const res = await fetch(CF, { 
        method: "POST", 
        headers: { "Content-Type": "application/json" }, 
        body: JSON.stringify(serverPayload) 
    });
    
    const d = await res.json();
    if (!d.variantId) throw new Error(t("temporaryProductError", "Erreur creation produit temporaire"));
    
    const cartProperties = {
        "_requestId": payload.requestId,
        "_partId": payload.partId, 
        "Technologie": payload.tech,
        "Matériau": payload.material,
        "Couleur": payload.color,
    };

    if (payload.layerHeight && payload.layerHeight !== "-") {
        cartProperties["Hauteur couche"] = `${payload.layerHeight} mm`;
    }

    if (payload.tech === 'FDM') {
        if (payload.infillDensity && payload.infillDensity !== "-") {
            cartProperties["Remplissage"] = `${payload.infillDensity}%`;
        }
        if (payload.wallCount && payload.wallCount !== "-") {
            cartProperties["Parois"] = payload.wallCount;
        }
        if (payload.shellLayers && payload.shellLayers !== "-") {
            cartProperties["Coques"] = payload.shellLayers;
        }
    }

    if (payload.printTime && payload.printTime !== "-") {
        cartProperties["Temps estimé"] = payload.printTime;
    }
    if (payload.dimensions && payload.dimensions.x !== "-") {
        cartProperties["Dimensions"] = `${payload.dimensions.x}x${payload.dimensions.y}x${payload.dimensions.z} mm`;
    }
    if (payload.weight && payload.weight !== "-") {
        cartProperties["Poids"] = `${payload.weight} g`;
    }

    await fetch("/cart/add.js", {
        method: "POST", 
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ 
            items: [{ 
                id: d.variantId, 
                quantity: payload.quantity, 
                properties: cartProperties 
            }] 
        })
    });
}

// --- Helpers Visuels ---
function captureViewerScreenshot() {
  if (!renderer) return null;
  renderer.render(scene, camera);
  return renderer.domElement.toDataURL('image/png');
}
function setPresetView(preset = 'FRONT') {
  if (!camera || !controls || !modelGroup || modelGroup.children.length === 0) return;
  const box = new THREE.Box3().setFromObject(modelGroup);
  const center = box.getCenter(new THREE.Vector3());
  const maxDim = Math.max(box.getSize(new THREE.Vector3()).x, box.getSize(new THREE.Vector3()).y, box.getSize(new THREE.Vector3()).z);
  const dist = maxDim / Math.tan((camera.fov * Math.PI) / 360) * 1.0;
  const views = { 'FRONT': [0,0,1], 'ISO': [1,1,1] };
  const dir = new THREE.Vector3(...(views[preset]||[0,0,1])).normalize();
  camera.position.set(center.x + dir.x*dist, center.y + dir.y*dist, center.z + dir.z*dist);
  camera.lookAt(center);
  controls.target.copy(center);
  controls.update();
  renderer.render(scene, camera);
}
function getFloor() { return scene.getObjectByName("dynamicFloor"); }
function captureFromPresetNoFloor(preset) {
  setPresetView(preset);
  const floor = getFloor();
  const old = floor ? floor.visible : true;
  if (floor) floor.visible = false;
  renderer.render(scene, camera);
  const data = renderer.domElement.toDataURL('image/png');
  if (floor) floor.visible = old;
  return data;
}
function dataURLtoBlob(dataurl) {
  const arr = dataurl.split(','), mime = arr[0].match(/:(.*?);/)[1], bstr = atob(arr[1]);
  let n = bstr.length, u8arr = new Uint8Array(n);
  while(n--) u8arr[n] = bstr.charCodeAt(n);
  return new Blob([u8arr], {type:mime});
}

// --- Nouvelle fonction pour uploader la capture d'écran ---
async function uploadScreenshotToFirebase(requestId, partId) {
  return new Promise((resolve) => {
    if (!renderer) return resolve(null);
    
    // 1. Cacher le sol pour la photo
    const floor = getFloor();
    const oldVisible = floor ? floor.visible : true;
    if (floor) floor.visible = false;
    
    // Forcer le rendu
    renderer.render(scene, camera);
    
    // 2. Générer le fichier image (Blob)
    renderer.domElement.toBlob(async (blob) => {
      // Rétablir le sol
      if (floor) floor.visible = oldVisible;
      
      if (!blob) {
          console.warn("⚠️ Blob vide");
          return resolve(null);
      }

      // Appel sécurisé à la fonction Liquid
      if (typeof window.uploadPreviewImageToFirebase === 'function') {
          const url = await window.uploadPreviewImageToFirebase(blob, requestId, partId);
          resolve(url);
      } else {
          console.error(t("uploadPreviewFunctionMissing", "Erreur: window.uploadPreviewImageToFirebase n'est pas definie dans le fichier Liquid."));
          resolve(null);
      }
    }, 'image/png');
  });
}
